import type { HapticsService } from "../HapticsService";
import type { HapticPatternName } from "../HapticPatterns";
import type { HapticPattern } from "../types";

/**
 * Dev-only decorator over the real `HapticsService`: forwards every call and records each
 * `play` (the pattern name, or `custom` for an inline pattern) so the debug hook can expose
 * the haptic sequence of a round next to the audio log.
 */
export class RecordingHapticsService implements HapticsService {
  public readonly entries: string[] = [];

  public constructor(private readonly inner: HapticsService) {}

  public get isSupported(): boolean {
    return this.inner.isSupported;
  }

  public get enabled(): boolean {
    return this.inner.enabled;
  }

  public setEnabled(enabled: boolean): void {
    this.inner.setEnabled(enabled);
  }

  public play(pattern: HapticPatternName | HapticPattern): void {
    this.entries.push(typeof pattern === "string" ? pattern : "custom");
    this.inner.play(pattern);
  }

  public cancel(): void {
    this.inner.cancel();
  }

  public destroy(): void {
    this.inner.destroy();
  }

  public clear(): void {
    this.entries.length = 0;
  }
}
